import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
    paddingRight: '12px'
  },
  title: {
    color: capitalDesignTokens.foundations.colors.ruby600
  },
  closeIcon: {
    color: capitalDesignTokens.foundations.colors.gray700
  },
  content: {
    padding: '0 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    '& .MuiFormHelperText-root': {
      paddingBottom: '0px'
    }
  },
  folderContentActionsContainer: {
    marginBottom: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  folderContentActionsLabel: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
    '&.Mui-focused': {
      color: capitalDesignTokens.foundations.colors.gray1000
    }
  }
});
